export default __webpack_public_path__ + "static/media/background.8bbf8744.jpg";